<template>
  <CreateEditProjectModal
    v-if="showCreateEditProjectModal"
    :projectId="projectId"
    @closeModal="closeCreateEditProjectModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Dados básicos</h6>
      <div v-if="canEditProject" class="ms-auto">
        <button
          type="button"
          class="btn btn-sm btn-warning"
          title="Editar Sumário Executivo"
          @click="showCreateEditProjectModal = true"
        >
          Editar Sumário Executivo
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <p><strong>Título:</strong> {{ project.title }}</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Período de Execução:</strong> {{ project.runtime }} (meses)
          </p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Status: </strong>
            <span v-html="statusProjectTranslate(project.status)" />
          </p>
        </div>
        <div class="col-md-12 col-sm-12">
          <p><strong>Descrição:</strong> {{ project.description }}</p>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <ul class="list-inline text-muted mb-0">
        <li class="list-inline-item">
          Cadastro por:
          {{ createdUpdatedUser(project.createdBy, project.createdAt) }}
        </li>
        <li class="list-inline-item">
          Atualizado por:
          {{ createdUpdatedUser(project.updatedBy, project.updatedAt) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CreateEditProjectModal from '@/components/projects/projects/CreateEditProjectModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import { mapGetters } from 'vuex'
import { createdUpdatedUser, statusProjectTranslate } from '@/utils/strings'

export default {
  name: 'DetailsProject',

  components: {
    CreateEditProjectModal,
    LoadingData,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditProjectModal: false,
      project: {},
      createdUpdatedUser,
      statusProjectTranslate,
    }
  },

  computed: {
    ...mapGetters(['canEditProject']),
  },

  methods: {
    async getProject() {
      try {
        this.project = await this.$store.dispatch('getProject', this.projectId)
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$router.push({
          name: 'Projects',
        })
      }
    },

    closeCreateEditProjectModal(loadProject) {
      if (loadProject) {
        this.getProject()
      }
      this.showCreateEditProjectModal = false
    },
  },

  mounted() {
    this.getProject()
  },
}
</script>
